
import { defineComponent, onMounted, ref, } from "vue"
export default defineComponent({
    name: "ModalDialog",
    props: {
        text: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: '下单失败'
        },
        query: {
            type: Boolean,
            default: false,
        }
    },
    setup(props, { emit }) {
        // const text = props.text
        const isShow = ref(true)
        const onCancel = () => {
            isShow.value = false
            emit('result', {})
        }
        const onQuery = () => {
            isShow.value = false
            emit('toQuery', {})
        }
        onMounted(() => {
            isShow.value = true
            console.log(isShow)
        })
        return {
            isShow,
            // text,
            onCancel,
            onQuery,
        };
    },
})
